exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-tab-group[data-v-5fe7ae8b] {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.horizontal[data-v-5fe7ae8b] {\n  flex-direction: row;\n  overflow-x: auto;\n  scrollbar-width: thin;\n  padding-bottom: 6px;\n}\n.horizontal > .sub-tab[data-v-5fe7ae8b] {\n  white-space: nowrap;\n}\n.vertical[data-v-5fe7ae8b] {\n  flex-direction: column;\n}", ""]);

// exports
